import React from 'react';
import advocateProfilePic from '../../../assets/images/advocates-details/srinitya.png';

const AdvocateSrinityaDetails = () => {
  return (
    <section className='team-details'>
      <div className='container'>
        <div className='row justify-content-between'>
          <div className='col-lg-5'>
            <div className='team-details__content'>
              <h2 className='team-details__title'>Read my story</h2>
              <p className='team-details__text'>
                Ms. Srinitya Joshi completed her BBA LLB from Symbiosis Law
                School, Hyderabad in the year 2023. Her experience includes
                internships in different subject matters and has interned in the
                chambers of reputed senior counsels, corporate law firms and
                established mediation and arbitration institutions. After
                graduating, she worked as Analyst in Contracts Team of leading
                corporate firm. She then went on to pursue LLM in Corporate and
                Financial Laws in O.P. Jindal Global University, Sonipat from
                2024-2025. She holds Advanced Diploma in Alternative Dispute
                Resolution from NALSAR University and Postgraduate Diploma in
                Environmental Laws from NLSIU, Bengaluru. Srinitya enrolled as
                an advocate in the year 2023 and her areas of interest include
                Corporate Laws, Civil Laws, Arbitration, Consumer Protection laws
                and Environmental laws.
              </p>
            </div>
          </div>
          <div className='col-lg-6'>
            <div className='team-one__single'>
              <div className='team-one__image' style={{ textAlign: 'center' }}>
                <img
                  src={advocateProfilePic}
                  alt='Srinitya Jaiteerth Joshi'
                  style={{
                    objectFit: 'cover',
                    objectPosition: 'center center',
                    display: 'block',
                    margin: '0 auto',
                    maxWidth: '100%',
                    height: 'auto',
                    border: 'none',
                    outline: 'none',
                    boxShadow: 'none'
                  }}
                />
              </div>
              <div className='team-one__content'>
                <h2 className='team-one__name'>Srinitya Jaiteerth Joshi. LLM</h2>
                <p className='team-one__designation'>Advocate</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AdvocateSrinityaDetails;

